import { API_URL } from '../config/constants';

export const getSatisfactionSurveysData = async (userName, passwd, filter = undefined) => {
    try {
        const request = new Request(API_URL + "/v2/getSatisfactionsStats", {
            method: 'POST',
            body: JSON.stringify({
                username: userName,
                password: passwd,
                filter: filter
            }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        });
        const response = await fetch(request);
        if (response.status !== 200 && response.code !== 200) throw response;
        const json = await response.json();
        return json.result.data;
    } catch (err) {
        if (!err.code && !err.status) err.status = 500;
        throw err;
    }
}

export const calculateTotal = (data, barKeys) => {
    for (let i = 0; i < barKeys.length; i++) {
        let total = 0;
        for (let j = 0; j < data.length; j++) {
            if (data[j][barKeys[i].key]) total += data[j][barKeys[i].key];
        }
        barKeys[i].total = total;
    }
    return barKeys;
}



// WEBPACK FOOTER //
// ./src/controllers/SatisfationResults.js